module.exports = __webpack_public_path__ + "e4955a4a379652efe5fe750778a4e9ad.MP3";